import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import * as fromSeriousSystem from '@serious-system';

@Component({
  selector: 'squadbox-conversation-drag-overlay',
  standalone: true,
  imports: [TranslateModule, fromSeriousSystem.UseUIBasicIconDirective],
  template: `
    @if (visible()) {
      <div
        class="fade-in absolute inset-0 z-30 flex items-center justify-center pointer-events-none bg-white/60"
      >
        <div
          class="flex flex-col items-center justify-center gap-4 select-none"
        >
          <svg
            [sdUseUIBasicIcon]="'document-circle-arrow-up'"
            class="size-10 text-primary-300"
          ></svg>
          <div class="flex flex-col items-center gap-2 text-center">
            <div class="typo-h6 font-semibold text-neutral-900">
              {{ 'CHAT.DRAG_AND_DROP.OVERLAY_TITLE' | translate }}
            </div>
            <div class="typo-p1 text-neutral-500">
              {{
                'CHAT.DRAG_AND_DROP.OVERLAY_SUBTITLE'
                  | translate: { maxDocuments: maxDocuments() }
              }}
            </div>
          </div>
        </div>
      </div>
    }
  `,
  host: {
    class: 'contents',
  },
})
export class ConversationDragOverlayComponent {
  public readonly visible = input<boolean>(false);
  public readonly maxDocuments = input<number>(3);
}
